<ng-content></ng-content>
@if (chevron()) {
    @if (header()) {
        <span></span>
    } @else {
        <i class="chevron fa-regular fa-chevron-right"></i>
    }
}
